import {
  required,
  email,
  max,
  min,
  confirmed,
  regex
} from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: "This field is required"
});

extend("max", {
  ...max,
  message: "This field must be {length} characters or less"
});

extend("min", {
  ...min,
  message: "This field must be {length} characters or more"
});

extend("passwordRegex", {
  ...regex,
  message:
    "This Field must contain an upper case letter, a numeric character, and a special character"
});

extend("contactRegex", {
  ...regex,
  message: "This Field must contain  valid uk format contact number"
});
extend("postcodeRegex", {
  ...regex,
  message: "This Field must contain valid uk format postcode"
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Password confirmation does not match"
});

extend("confirmed", {
  ...confirmed,
  message: "The password confirmation does not match"
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});

extend("commentRegex", {
  ...regex,
  message: "This Field only contains alphabetic letters and numeric letters"
});
